/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum VoucherType {
  VoucherTypeUnknown = "VoucherTypeUnknown",
  Voucher = "Voucher",
  Debit = "Debit",
}

export function voucherTypeFromJSON(object: any): VoucherType {
  switch (object) {
    case 0:
    case "VoucherTypeUnknown":
      return VoucherType.VoucherTypeUnknown;
    case 1:
    case "Voucher":
      return VoucherType.Voucher;
    case 2:
    case "Debit":
      return VoucherType.Debit;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum VoucherType"
      );
  }
}

export function voucherTypeToJSON(object: VoucherType): string {
  switch (object) {
    case VoucherType.VoucherTypeUnknown:
      return "VoucherTypeUnknown";
    case VoucherType.Voucher:
      return "Voucher";
    case VoucherType.Debit:
      return "Debit";
    default:
      return "UNKNOWN";
  }
}

export function voucherTypeToNumber(object: VoucherType): number {
  switch (object) {
    case VoucherType.VoucherTypeUnknown:
      return 0;
    case VoucherType.Voucher:
      return 1;
    case VoucherType.Debit:
      return 2;
    default:
      return 0;
  }
}

export enum RedeemType {
  RedeemTypeUnknown = "RedeemTypeUnknown",
  And = "And",
  Or = "Or",
}

export function redeemTypeFromJSON(object: any): RedeemType {
  switch (object) {
    case 0:
    case "RedeemTypeUnknown":
      return RedeemType.RedeemTypeUnknown;
    case 1:
    case "And":
      return RedeemType.And;
    case 2:
    case "Or":
      return RedeemType.Or;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum RedeemType"
      );
  }
}

export function redeemTypeToJSON(object: RedeemType): string {
  switch (object) {
    case RedeemType.RedeemTypeUnknown:
      return "RedeemTypeUnknown";
    case RedeemType.And:
      return "And";
    case RedeemType.Or:
      return "Or";
    default:
      return "UNKNOWN";
  }
}

export function redeemTypeToNumber(object: RedeemType): number {
  switch (object) {
    case RedeemType.RedeemTypeUnknown:
      return 0;
    case RedeemType.And:
      return 1;
    case RedeemType.Or:
      return 2;
    default:
      return 0;
  }
}

export interface PriceStep {
  value: number;
  minPrice: number;
  maxPrice: number;
}

export interface WebsitePromo {
  value: number;
  code: string;
  validUntil: string;
  conditionsUrl: string;
  priceSteps: PriceStep[];
}

function createBasePriceStep(): PriceStep {
  return { value: 0, minPrice: 0, maxPrice: 0 };
}

export const PriceStep = {
  encode(
    message: PriceStep,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.value !== 0) {
      writer.uint32(8).uint32(message.value);
    }
    if (message.minPrice !== 0) {
      writer.uint32(16).uint32(message.minPrice);
    }
    if (message.maxPrice !== 0) {
      writer.uint32(24).uint32(message.maxPrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceStep {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.value = reader.uint32();
          break;
        case 2:
          message.minPrice = reader.uint32();
          break;
        case 3:
          message.maxPrice = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceStep {
    return {
      value: isSet(object.value) ? Number(object.value) : 0,
      minPrice: isSet(object.minPrice) ? Number(object.minPrice) : 0,
      maxPrice: isSet(object.maxPrice) ? Number(object.maxPrice) : 0,
    };
  },

  toJSON(message: PriceStep): unknown {
    const obj: any = {};
    message.value !== undefined && (obj.value = Math.round(message.value));
    message.minPrice !== undefined &&
      (obj.minPrice = Math.round(message.minPrice));
    message.maxPrice !== undefined &&
      (obj.maxPrice = Math.round(message.maxPrice));
    return obj;
  },

  fromPartial(object: DeepPartial<PriceStep>): PriceStep {
    const message = createBasePriceStep();
    message.value = object.value ?? 0;
    message.minPrice = object.minPrice ?? 0;
    message.maxPrice = object.maxPrice ?? 0;
    return message;
  },
};

function createBaseWebsitePromo(): WebsitePromo {
  return {
    value: 0,
    code: "",
    validUntil: "",
    conditionsUrl: "",
    priceSteps: [],
  };
}

export const WebsitePromo = {
  encode(
    message: WebsitePromo,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.value !== 0) {
      writer.uint32(16).uint32(message.value);
    }
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.validUntil !== "") {
      writer.uint32(26).string(message.validUntil);
    }
    if (message.conditionsUrl !== "") {
      writer.uint32(34).string(message.conditionsUrl);
    }
    for (const v of message.priceSteps) {
      PriceStep.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebsitePromo {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebsitePromo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.value = reader.uint32();
          break;
        case 1:
          message.code = reader.string();
          break;
        case 3:
          message.validUntil = reader.string();
          break;
        case 4:
          message.conditionsUrl = reader.string();
          break;
        case 5:
          message.priceSteps.push(PriceStep.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): WebsitePromo {
    return {
      value: isSet(object.value) ? Number(object.value) : 0,
      code: isSet(object.code) ? String(object.code) : "",
      validUntil: isSet(object.validUntil) ? String(object.validUntil) : "",
      conditionsUrl: isSet(object.conditionsUrl)
        ? String(object.conditionsUrl)
        : "",
      priceSteps: Array.isArray(object?.priceSteps)
        ? object.priceSteps.map((e: any) => PriceStep.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebsitePromo): unknown {
    const obj: any = {};
    message.value !== undefined && (obj.value = Math.round(message.value));
    message.code !== undefined && (obj.code = message.code);
    message.validUntil !== undefined && (obj.validUntil = message.validUntil);
    message.conditionsUrl !== undefined &&
      (obj.conditionsUrl = message.conditionsUrl);
    if (message.priceSteps) {
      obj.priceSteps = message.priceSteps.map((e) =>
        e ? PriceStep.toJSON(e) : undefined
      );
    } else {
      obj.priceSteps = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<WebsitePromo>): WebsitePromo {
    const message = createBaseWebsitePromo();
    message.value = object.value ?? 0;
    message.code = object.code ?? "";
    message.validUntil = object.validUntil ?? "";
    message.conditionsUrl = object.conditionsUrl ?? "";
    message.priceSteps =
      object.priceSteps?.map((e) => PriceStep.fromPartial(e)) || [];
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
